import gql from 'graphql-tag'
import { notificationFragment } from "@/graphql/notification/notificationFragments";
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
import { assignmentFragment } from "@/graphql/assignment/assignmentFragments";
import { tagFragment, customTagFragment, customTagLabelFragment } from '@/graphql/tag/tagFragments'
import { resourceFragment, resourceTypeFragment, staffVehiculeFragment } from "@/graphql/resource/resourceFragments";
// import { /*projectFragment,*/ projectSummaryFragment } from "@/graphql/project/projectFragments";

/*export const ACCEPTNOTIFICATIONASSIGNMENT = gql`
    mutation acceptAssignment(
        $assignmentID: ID
        $projectID: ID
        $notificationID: ID
        $page: Int = 1
        $first: Int = 25
    ){
        acceptAssignment(
            input: {
                assignmentID: $assignmentID
                projectID: $projectID
                notificationID: $notificationID
                page: $page
                first: $first 
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...notificationFragment
                created_by{
                    // ...userProfileFragment
                }
            }
        }
    }
    ${notificationFragment}
    ${userProfileFragment}
`*/

export const MARKASREAD = gql`
    mutation markAsRead(
        $id: ID!
    ){
        markAsRead(
            id: $id
        ){
            ...notificationFragment
            recipients{
                id
                name
                email
            }
            created_by{
                id
                name
                email
            }
            updated_by{
                id
                name
                email
            }
            conversations{
                id
                message
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            lastConversation{
                id
            #    subject
                message
                read
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
        }
    }
    ${notificationFragment}
`

export const REPLYNOTIFICATION = gql`
    mutation replyNotification(
            $subject: String
            $message: String
            $notificationID: ID!
            $replyingToID: ID
            $replyingToMessage: String
        ){
        replyNotification(
            subject: $subject
            message: $message
            notificationID: $notificationID
            replyingToID: $replyingToID
            replyingToMessage: $replyingToMessage
        ){
            ...notificationFragment
            #relationsData

            #recipients{
            #    id
            #    name
            #    email
            #}
            #created_by{
            #    id
            #    name
            #    email
            #}
            updated_by{
                id
                name
                email
            }
            conversations{
                id
                info
                subject
                type
                message
                replying_to_id
                replying_to_message
                infoAssignment{
                    id
                    date
                    profession{
                        id
                        name
                    }
                    assignedTo{
                        id
                        name
                        email
                    }
                }
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            lastConversation{
                id
            #    subject
                message
                read
                created_by{
                    id
                    name
                    email
                }
                created_at
            }

        }
    }
    ${notificationFragment}
`

export const SENDMESSAGE = gql`
    mutation sendMessage(
            $subject: String
            $message: String
            $to: [ID]!
            $projectID: ID
            $assignmentID: ID
            $projectShiftID: ID
            $shiftID: ID
        ){
        sendMessage(
            subject: $subject
            message: $message
            projectID: $projectID
            assignmentID: $assignmentID
            projectShiftID: $projectShiftID
            shiftID: $shiftID
            to: $to
        ){
            ...notificationFragment
            created_by{
                id
                name
                email
            }
        }
    }
    ${notificationFragment}
`


export const DELETENOTIFICATIONS = gql`
    mutation deleteNotifications(
        $id: [ID]!
    ){
        deleteNotifications(
            id: $id
        ){
            ...notificationFragment
            recipients{
                id
                name
                email
            }
            created_by{
                id
                name
                email
            }
            updated_by{
                id
                name
                email
            }
            conversations{
                id
                message
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            lastConversation{
                id
            #    subject
                message
                read
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
        }
    }
    ${notificationFragment}
`
export const DELETENOTIFICATIONSTHREAD = gql`
    mutation deleteNotificationsThread(
        $id: ID!
    ){
        deleteNotificationsThread(
            id: $id
        ){
            ...notificationFragment
            recipients{
                id
                name
                email
            }
            created_by{
                id
                name
                email
            }
            updated_by{
                id
                name
                email
            }
            conversations{
                id
                message
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            lastConversation{
                id
            #    subject
                message
                read
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
        }
    }
    ${notificationFragment}
`

export const DELETEPROJECTNOTIFICATIONS = gql`
    mutation deleteProjectNotifications(
        $projectID: ID!
    ){
        deleteProjectNotifications(
            projectID: $projectID
        ){
            ...notificationFragment
            created_by{
                id
                name
                email
            }
        }
    }
    ${notificationFragment}
`


export const ACCEPTNOTIFICATIONASSIGNMENT = gql`
    mutation acceptAssignment(
        $assignmentID: [ID!]!
        $projectID: ID
        $notificationID: ID
        $userProfileID: ID!
        $action: String!
        $message: String
        $page: Int = 1
        $first: Int = 25
        $result: Boolean = false
    ){
        acceptAssignment(
            input: {
                assignmentID: $assignmentID
                projectID: $projectID
                notificationID: $notificationID
                userProfileID: $userProfileID
                action: $action
                message: $message
                page: $page
                first: $first 
                result: $result
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...assignmentFragment
                profession{
                    ...tagFragment
                }
                shift {
                    id
                    name
                }
                project {
                    id
                    name
                }
                projectShift {
                    id
                    name
                    description
                    courses{
                        ...tagFragment
                    }
                    skills{
                        ...tagFragment
                    }
                    customtags{
                        ...customTagFragment
                        label{
                            ...customTagLabelFragment
                        }
                    }
                    resources{
                        ...resourceFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                    staffVehicules{
                        ...staffVehiculeFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                }
            }
        }
    }
    ${assignmentFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${customTagLabelFragment}
    ${resourceTypeFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
`
export const BATCHACCEPTNOTIFICATIONASSIGNMENT = gql`
    mutation batchAcceptAssignment(
        $projectID: ID!
        $projectShiftID: ID
        $notificationID: ID
        $userProfileID: ID
        $action: String!
        $message: String
        $page: Int = 1
        $first: Int = 125
        $result: Boolean = false
    ){
        batchAcceptAssignment(
            input: {
                projectID: $projectID
                projectShiftID: $projectShiftID
                notificationID: $notificationID
                userProfileID: $userProfileID
                action: $action
                message: $message
                page: $page
                first: $first 
                result: $result
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...assignmentFragment
                profession{
                    ...tagFragment
                }
                shift {
                    id
                    name
                }
                project {
                    id
                    name
                }
                projectShift {
                    id
                    name
                    description
                    courses{
                        ...tagFragment
                    }
                    skills{
                        ...tagFragment
                    }
                    customtags{
                        ...customTagFragment
                        label{
                            ...customTagLabelFragment
                        }
                    }
                    resources{
                        ...resourceFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                    staffVehicules{
                        ...staffVehiculeFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                }
            }
        }
    }
    ${assignmentFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${customTagLabelFragment}
    ${resourceTypeFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
`

// export const ACCEPTNOTIFICATIONASSIGNMENTEXTENDED = gql`
//     mutation acceptAssignment(
//         $assignmentID: ID
//         $projectID: ID
//         $notificationID: ID
//         $userProfileID: ID!
//         $action: String!
//         $message: String
//         $page: Int = 1
//         $first: Int = 25
//         $result: Boolean = false
//         $shiftsDateRange: activeDuringInputSingleDate!
//     ){
//         acceptAssignment(
//             input: {
//                 assignmentID: $assignmentID
//                 projectID: $projectID
//                 notificationID: $notificationID
//                 userProfileID: $userProfileID
//                 action: $action
//                 message: $message
//                 page: $page
//                 first: $first 
//                 result: $result
//             }
//         ){
//             paginatorInfo{
//                 count
//                 perPage
//                 currentPage
//                 hasMorePages
//             }
//             data{
//                 ...assignmentFragment
//                 profession{
//                     ...tagFragment
//                 }
//                 shift {
//                     name
//                 }
//                 project {
//                     ...projectSummaryFragment
//                 }
//                 projectShift {
//                     id
//                     name
//                     description
//                     courses{
//                         ...tagFragment
//                     }
//                     skills{
//                         ...tagFragment
//                     }
//                     customtags{
//                         ...customTagFragment
//                         label{
//                             ...customTagLabelFragment
//                         }
//                     }
//                     resources{
//                         ...resourceFragment
//                         type{
//                             ...resourceTypeFragment
//                         }
//                     }
//                     staffVehicules{
//                         ...staffVehiculeFragment
//                         type{
//                             ...resourceTypeFragment
//                         }
//                     }
//                 }
//             }
//         }
//     }
//     ${assignmentFragment}
//     ${tagFragment}
//     ${customTagFragment}
//     ${customTagLabelFragment}
//     ${customTagLabelFragment}
//     ${resourceTypeFragment}
//     ${resourceFragment}
//     ${staffVehiculeFragment}
//     ${projectSummaryFragment}
// `